import React from 'react'

const Requests = () => {
  return (
    <div>
        <h1>Schedule an Invite with us.</h1>
    </div>
  )
}

export default Requests